import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  OnChanges,
  SimpleChanges,
  Input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { NgToastService } from 'ng-angular-popup';
import { MatMenuModule } from '@angular/material/menu';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ApiService } from '@/app/services/shared/api.service';
import { MatGridListModule } from '@angular/material/grid-list';

import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
export enum USER_ROLE_MESSAGES {
  REQUIRED_FIELDS_MISSING = 'Fill all the require fields',
  ADD_PERMISSION = 'Permission added successfully!',
  UPDATE_PERMISSION = 'Permission updated successfully!',
  DELETE_PERMISSION = 'Permission deleted successfully!',
}
@Component({
  selector: 'app-permissions',
  standalone: true,
  imports: [
    CommonModule,
    MatTabsModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCardModule,
    DragDropModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatGridListModule,
  ],
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.css'],
})
export class PermissionsComponent implements OnInit, OnChanges {
  @Input() isDialogOpen!: boolean;
  @Input() selectedTab!: string;
  @ViewChild('addPermissionDialog') addPermissionDialog!: TemplateRef<any>;
  @ViewChild('viewDetailDialog') viewDetailDialog!: TemplateRef<any>;
  roles: any[] = [];
  permissions: any[] = [];
  editPermissionId: number;
  availablePermissions: string[] = [];
  permissionDetail: any;
  permissionForm = new FormGroup({
    permissionName: new FormControl('', Validators.required),
    roles: new FormControl('', Validators.required),
  });

  constructor(
    private apiService: ApiService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private toast: NgToastService
  ) {}

  ngOnInit(): void {
    this.loadRoles();
    this.loadPermissions();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['isDialogOpen'] &&
      !changes['isDialogOpen'].firstChange &&
      this.selectedTab === 'permissions'
    ) {
      this.editPermissionId = null;
      this.permissionForm.reset();
      this.openAddPermissionDialog();
    }
  }
  openAddPermissionDialog() {
    this.dialog.open(this.addPermissionDialog, {
      disableClose: true,
      autoFocus: false,
    });
  }
  loadRoles() {
    this.apiService.getRoles().subscribe((data) => {
      this.roles = data;
    });
  }
  loadPermissions() {
    this.apiService.getPermissions().subscribe((data) => {
      this.permissions = data;
      this.availablePermissions = this.permissions.map((p: any) => p.name);
    });
  }
  getRoleNames(role: any[]): string {
    return role?.map((p) => p.name).join(', ') || 'No Role assigned';
  }
  async createPermission() {
    const dataToSubmit: any = await this.preparePermissionDataToSubmit();
    if (this.editPermissionId) {
      this.apiService
        .updatePermission(dataToSubmit, this.editPermissionId)
        .subscribe({
          next: () => {
            // if (response.meta.success) {
            this.toast.success(
              USER_ROLE_MESSAGES.UPDATE_PERMISSION,
              'SUCCESS',
              4000
            );
            this.permissionForm.reset();
            this.loadPermissions();
            this.closeDialog();
            // }
          },
          error: (error: any) => {
            this.toast.danger(error.error.message, 'DANGER', 4000);
          },
        });
    } else {
      this.apiService.createPermission(dataToSubmit).subscribe({
        next: () => {
          // if (response.meta.success) {
          this.toast.success(
            USER_ROLE_MESSAGES.ADD_PERMISSION,
            'SUCCESS',
            4000
          );
          this.permissionForm.reset();
          this.loadPermissions();
          this.closeDialog();
          // }
        },
        error: (error: any) => {
          this.toast.danger(error.error.message, 'DANGER', 4000);
        },
      });
    }
  }

  async preparePermissionDataToSubmit() {
    if (this.permissionForm.invalid) {
      this.toast.warning(
        USER_ROLE_MESSAGES.REQUIRED_FIELDS_MISSING,
        'WARNING',
        4000
      );
      this.permissionForm.markAllAsTouched();
      return;
    }
    const dataToSubmit = {
      name: this.permissionForm.value.permissionName,
      role_ids: this.permissionForm.value.roles,
    };
    return dataToSubmit;
  }
  // Close the dialog
  closeDialog() {
    this.dialog.closeAll();
  }
  editPermission(permission: any) {
    // Patch values into the form
    this.permissionForm.patchValue({
      permissionName: permission?.name,
      roles: permission.roles.map((role) => role?.id),
    });
    this.editPermissionId = permission?.id;
    this.dialog.open(this.addPermissionDialog);
  }
  deletePermission(permissionId: number) {
    this.apiService.deletePermission(permissionId).subscribe({
      next: (response: any) => {
        if (response.meta.success) {
          this.toast.success(
            USER_ROLE_MESSAGES.DELETE_PERMISSION,
            'SUCCESS',
            4000
          );
          this.loadPermissions();
        }
      },
      error: (error: any) => {
        this.toast.danger(error.error.message, 'DANGER', 4000);
      },
    });
  }
  openViewDetailDialog(permission: any) {
    this.permissionDetail = permission;
    this.dialog.open(this.viewDetailDialog, {
      disableClose: true,
      autoFocus: false,
    });
  }
}
